// BlogPost Page
export default function BlogPost() { return <div><h1 className="text-4xl font-bold text-center py-20">Blog Post</h1></div>; }